export function premierTier(rating) {
  if (rating >= 30000) return { c: '#FFD24A', name: 'ЭЛИТА' };
  if (rating >= 25000) return { c: '#F0454B', name: 'КРАСНЫЙ' };
  if (rating >= 20000) return { c: '#E0588E', name: 'РОЗОВЫЙ' };
  if (rating >= 15000) return { c: '#A06CF0', name: 'ФИОЛЕТ' };
  if (rating >= 10000) return { c: '#4B7BEC', name: 'СИНИЙ' };
  if (rating >= 5000)  return { c: '#3AC6E0', name: 'ГОЛУБОЙ' };
  return { c: '#9AA0A8', name: 'СЕРЫЙ' };
}

export default function PremierBadge({ rating = 0, size = 'md' }) {
  const t = premierTier(rating);
  const dims = size === 'sm'
    ? { h: 26, fs: 12, px: 9, star: 9 }
    : size === 'lg'
    ? { h: 44, fs: 19, px: 16, star: 14 }
    : { h: 34, fs: 15, px: 12, star: 11 };
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 7, height: dims.h, padding: `0 ${dims.px}px`,
      fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: dims.fs, color: '#0b0b0d',
      background: `linear-gradient(120deg, ${t.c}, ${t.c}cc)`,
      clipPath: 'polygon(8px 0, 100% 0, calc(100% - 8px) 100%, 0 100%)',
      boxShadow: `0 4px 18px -6px ${t.c}99`,
    }}>
      <svg width={dims.star} height={dims.star} viewBox="0 0 24 24" fill="#0b0b0d">
        <path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z" />
      </svg>
      {rating.toLocaleString('ru-RU')}
    </span>
  );
}
